angular.module("questionarioAdv.module")
    .component("eventiLog", {
        templateUrl: "ng/components/questionarioAdv/eventiLog/eventiLog.view.html",
        bindings: {
            listEvent: '<',
        },
        controller: EventiLogController,
        controllerAs: 'eventiLogCtrl'
    })

function EventiLogController(
    $portalService
) {

    var self = this;

    self.$onInit = () => {


        self.isAru = $portalService.isAru();


    }
}